import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { PageLayout } from '@kamernet/core/PageLayout';
import { NavLink } from '@kamernet/core/Routing/NavLink';

import TipsAndArticles1 from '../../images/TipsAndArticles1.webp';
import TipsAndArticles2 from '../../images/TipsAndArticles2.webp';
import TipsAndArticles3 from '../../images/TipsAndArticles3.webp';

import styles from './TipsAndArticles.module.css';

export const TipsAndArticles = () => {
  const { T } = useIntl();

  return (
    <PageLayout.SectionContainer className={styles.root}>
      <Typography variant="h2" className={styles.title}>
        {T('LBL_HOME_SUPPLY_BLOG_GENERAL_TITLE')}
      </Typography>
      <div className={styles.tips}>
        <div>
          <NavLink.Native
            color="primary"
            underline="none"
            href="/tips/verhuurders/huurprijs/hoe-bepaal-je-de-huurprijs"
          >
            <img
              src={TipsAndArticles1.src}
              alt="LBL_HOME_SUPPLY_BLOG_1_TITLE"
            />
            <Typography variant="body2">
              {T('LBL_HOME_SUPPLY_BLOG_1_TITLE')}
            </Typography>
          </NavLink.Native>
        </div>
        <div>
          <NavLink.Native
            color="primary"
            underline="none"
            href="/tips/international-students/moving/an-example-rental-agreement-in-english-for-your-stay-in-the-netherlands"
          >
            <img
              src={TipsAndArticles2.src}
              alt="LBL_HOME_SUPPLY_BLOG_2_TITLE"
            />
            <Typography variant="body2">
              {T('LBL_HOME_SUPPLY_BLOG_2_TITLE')}
            </Typography>
          </NavLink.Native>
        </div>
        <div>
          <NavLink.Native
            color="primary"
            underline="none"
            href="/tips/international-students"
          >
            <img
              src={TipsAndArticles3.src}
              alt="LBL_HOME_SUPPLY_BLOG_3_TITLE"
            />
            <Typography variant="body2">
              {T('LBL_HOME_SUPPLY_BLOG_3_TITLE')}
            </Typography>
          </NavLink.Native>
        </div>
      </div>
    </PageLayout.SectionContainer>
  );
};
